export const projectData = [
    {
        title: 'Automation',
        intro: 'Fashion artisans at work',
        content: `
               Now, when anything attracted his attention he always asked what it meant; and his mother, or
                            more frequently Uncle Maxim, would explain to him the nature of the objects or of the
                            creatures that caused these various sounds.
                       His mother’s explanations, more lively and graphic, impressed the boy with greater force; but
                            sometimes this impression would be too painful. 
                       Upon the features of the young woman, herself suffering, could be read the expression of her
                            inmost feelings, and in her eyes a silent protest or a look of pain, as she strove to convey
                            to the child an idea of form and color.
        `,
        imgSrc: '1.jpg',
    },
    {
        title: 'Machines',
        intro: 'Contemporary makeup art',
        content: `Thus blindness proved no drawback to systematic physical development, while its influence
                            over the moral nature of the child was reduced to its minimum. He was tall for his age and
                            well built; his face was somewhat pale, his features fine and expressive.
                        His dark hair enhanced the pallid hue of his complexion, while his eyes—large, dark, and
                            almost motionless—gave him a peculiar aspect that at once attracted attention
                        A slight wrinkle between his eye-brows, a habit of inclining his head slightly forward, and
                            the expression of sadness that[93] sometimes overcast his handsome face — these were the
                            outward tokens of his blindness.`,
        imgSrc: '2.jpg',
    },
    {
        title: 'Coexistence',
        intro: 'Adventures in Moscow',
        content: `The impressions received through the channels of sound outweighed all others in their
                            influence over the life of the blind boy; his ideas shaped themselves according to sounds,
                            his sense of hearing became the centre of his mental activity.
        The enchanting melodies of the songs he heard conveyed to him a true sense of the words,
                            coloring them with sadness or joy according to the lights and shades of the melody. 
        He quickly learned all his mother taught him on the piano, and yet he still loved Joachim’s
                            pipe.`,
        imgSrc: '3.jpg',
    },
    {
        title: 'Bellamio',
        intro: 'Gucci festival feature',
        content: `Thus the boy’s day was filled; he could not complain of the lack of new impressions. 
                        He seemed to be living as full a life as any child could possibly live; in fact he really
                            seemed unconscious of his blindness.
                        Nevertheless, a certain premature sadness was still perceptible in his character, which Maxim
                            ascribed to the fact that he had never mingled with other children, and endeavored to atone
                            for this omission.`
,
        imgSrc: '4.jpg',
    },{
        title: 'Pastures',
        intro: 'Gucci festival feature',
        content: `Thus the boy’s day was filled; he could not complain of the lack of new impressions. 
                        He seemed to be living as full a life as any child could possibly live; in fact he really
                            seemed unconscious of his blindness.
                        Nevertheless, a certain premature sadness was still perceptible in his character, which Maxim
                            ascribed to the fact that he had never mingled with other children, and endeavored to atone
                            for this omission.`
,
        imgSrc: '5.jpg',
    },{
        title: 'Focus',
        intro: 'Gucci festival feature',
        content: `Thus the boy’s day was filled; he could not complain of the lack of new impressions. 
                        He seemed to be living as full a life as any child could possibly live; in fact he really
                            seemed unconscious of his blindness.
                        Nevertheless, a certain premature sadness was still perceptible in his character, which Maxim
                            ascribed to the fact that he had never mingled with other children, and endeavored to atone
                            for this omission.`
,
        imgSrc: '6.jpg',
    },
];

